/*
 * @Description: 选择商品弹窗组件
 * @Author: your name
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import { Balloon, Button, Dialog, Form, Input, Tab, Table } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import LzMsg from '@/components/common/LzMsg';
import { Servlets } from '@/service';
import styles from './index.module.scss';

const CrowdTagSelectGoodProductId = (props) => {
  const { Tooltip } = Balloon;
  /**
   * @param goodsDialog 是否展示弹窗
   * @closeDialog 关闭弹窗方法
   * @param skuIds 选中的skuid
   * @param confirmSkuid 传skuid给父组件
   * @param selectGoods 选中的商品
   * @param confirmGoods 传选中商品给父组件
   * @param maxGoodsNum 最大选择商品数量
   */
  const { goodsDialog, closeDialog, skuIds, confirmSkuid, selectGoods, confirmGoods, maxGoodsNum } = props;

  // 选择的商品是否被更改过
  const [hasCheck, setHasChecked] = useState(false)
  // table的数据
  const [goodsList, setGoodsList] = useState([]);
  // table的loading
  const [goodsLoading, setGoodsLoading] = useState(false);
  // sku查询条件
  const [skuSearch, setSkuSearch] = useState('');
  // SKU弹窗，被选中的商品的id数组
  const [skuCheckedId, setSkuCheckedId] = useState([]);
  // SKU弹窗，被选中的商品的数据
  const [skuChecked, setSkuChecked] = useState([]);
  // SKU弹窗，被选中的商品的id数组临时数据
  const [skuCheckedIdCopy, setSkuCheckedIdCopy] = useState([]);
  // SKU弹窗，被选中的商品的临时数据
  const [skuCheckedCopy, setSkuCheckedCopy] = useState([]);
  // 导入商品tab 用户手动输入sku输入框
  const [handleInput, setHandleInput] = useState('');
  // 导入商品结果
  const [importResult, setImportResult] = useState({
    successNum: 0,
    failedNum: 0,
  });
  // 商品分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 5,
    total: 0,
  });
  // 商品翻页方法
  const handlePageSizeChange = async (pages = {}) => {
    // setLoading(true);
    try {
      // setPageInfo({
      //   ...pageInfo,
      //   ...pages,
      // });
      // TODO 请求后端列表接口
      getSkuList({ pageSize: pages.pageSize, pageNo: pages.pageNo, skuIds: '' });
    } catch (e) {
      // setLoading(false);
      LzMsg.error(e.message);
    }
  };
  // 选择商品数据
  const getSkuList = (v) => {
    setGoodsLoading(true);
    const params = {
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      skuIds: skuSearch,
      product: '1', // 无用标识符，给人群标签商品组件展示
      ...v,
    };
    Servlets('getGoodsSpu', params).then((res) => {
      setGoodsList(res.data);
      setPageInfo({ ...pageInfo, pageNo: res.page.pageNo, pageSize: res.page.pageSize, total: res.page.total });
      setGoodsLoading(false);
    }).catch((err) => {
      setGoodsLoading(false);
    });
  };
  // sku选中商品触发
  const changeSkusHandle = (args, record) => {
    // skuid去重
    args = Array.from(new Set(args));
    setSkuCheckedIdCopy(args);
    //  添加操作 把record里新选的都赋值到skuChecked里
    const tempChecked = JSON.parse(JSON.stringify(skuCheckedCopy));
    record.forEach((item) => {
      tempChecked.push(item);
    });
    // 对已选商品skuChecked去重
    const hash = {};
    const newArray = tempChecked.reduce((item, next) => {
      hash[next.productId] ? '' : hash[next.productId] = true && item.push(next);
      return item;
    }, []);
    // 过滤掉未勾选的商品
    const finalArr = newArray.filter((item) => args.indexOf(item.productId) > -1);
    setSkuCheckedCopy(finalArr);
  };
  // 手动输入商品sku确认导入函数
  const handleInputConfirm = () => {
    const tempParams = handleInput;
    const filterArr = tempParams.replace(/[\r\n]/g, ',').split(',').filter((item) => {
      return item.length !== 0;
    });
    if (filterArr.length > 999) {
      LzMsg.error('最多输入999个sku');
    } else if (filterArr.length === 0) {
      LzMsg.error('请输入sku！');
    } else {
      Servlets('getGoodsSpu', {
        pageSize: 1000000,
        pageNo: 1,
        skuIds: tempParams.replace(/[\r\n]/g, ','),
      }).then((res) => {
        setImportResult({
          successNum: res.data.length,
          failedNum: (filterArr.length) - res.data.length,
        });
        const tempArr = [];
        res.data.forEach((item, index) => {
          tempArr.push(item.productId);
        });
        // 让tab1对应商品被选中
        setSkuCheckedIdCopy(Array.from(new Set(skuCheckedIdCopy.concat(tempArr))));
        // 对已选商品skuChecked去重
        const tempChecked = skuCheckedCopy.concat(res.data);
        const hash = {};
        const newArray = tempChecked.reduce((item, next) => {
          hash[next.productId] ? '' : hash[next.productId] = true && item.push(next);
          return item;
        }, []);
        setSkuCheckedCopy(newArray);
      });
    }
  };
  // 点击确认按钮
  const handleConfirm = () => {
    if(maxGoodsNum && skuCheckedCopy.length > maxGoodsNum) {
      LzMsg.error(`最多选择${maxGoodsNum}个商品`);
      return;
    }
    setHasChecked(true)
    setGoodsList([]);
    setSkuSearch(''); // 清空搜索框
    // confirmSkuid("11111"); //skuid传给父组件
    confirmSkuid(skuCheckedIdCopy); // skuid传给父组件
    confirmGoods(skuCheckedCopy); // 商品传给父组件
    setSkuCheckedId(skuCheckedIdCopy); // 把临时的id赋值给skuid
    setSkuChecked(skuCheckedCopy); // 把临时的商品赋值给选中商品
    setHandleInput(''); // 清空输入的sku
    setImportResult({ successNum: 0, failedNum: 0 });
    closeDialog();
  };
  // 点击取消按钮
  const handleCancel = () => {
    setGoodsList([]);
    setSkuSearch('');
    setSkuCheckedIdCopy(skuCheckedId); // 把选中的skuid赋值给临时id
    setSkuCheckedCopy(skuChecked); // 把选中的商品赋值给临时商品
    setHandleInput(''); // 清空输入的sku
    setImportResult({ successNum: 0, failedNum: 0 });
    closeDialog();
  };
  useEffect(() => {
    getSkuList();
  }, []);
  useEffect(() => {
    // 父组件删除商品的时候，子组件也删除商品
    if (skuIds.length === 0) {
      // 如果skuids的长度是0，说明是清除全部
      setSkuCheckedId([]);
      setSkuChecked([]);
      setSkuCheckedIdCopy([]);
      setSkuCheckedCopy([]);
    } else if(hasCheck && skuIds.length !== 0) {
      const arr = [];
      skuCheckedId.forEach((item) => {
        selectGoods.forEach((i) => {
          if (item === i.productId) {
            arr.push(item);
          }
        });
      });
      setSkuCheckedId(arr);
      setSkuChecked(selectGoods);
      setSkuCheckedIdCopy(arr);
      setSkuCheckedCopy(selectGoods);
    }
  }, [selectGoods]);
  useEffect(() => {
    if (skuIds.length > 0) {
      Servlets('getGoodsSpu', {
        pageSize: skuIds.length,
        pageNo: 1,
        skuIds: skuIds.toString(),
      }).then((res) => {
        const arr = [];
        if(res.data) {
          res.data.forEach((item) => {
            arr.push(item.productId);
          });
        }
        setSkuCheckedIdCopy(arr);
        setSkuCheckedId(arr);
        setSkuChecked(res.data);
        setSkuCheckedCopy(res.data);
        confirmGoods(res.data);
      });
    }
    //  skuIds变化触发
  }, [skuIds]);
  return (
    <div>
      <Dialog
        title="选择商品"
        footer={false}
        isFullScreen
        visible={goodsDialog}
        shouldUpdatePosition
        style={{ width: `${document.documentElement.clientWidth * 0.8 }px` }}
        onClose={handleCancel}
      >
        <div className={styles.peopledialogContent}>
          <div className="goods-tab">
            <Tab shape="capsule">
              {/* Tab1-按sku选择 */}
              <Tab.Item title="全部商品" key="1" style={{ width: '120px', textAlign: 'center' }}>
                <div className={styles.skuForm}>
                  <Form style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }} className={styles.peopleForm}>
                    <Form.Item label="商品ID" style={{ flex: 1, marginRight: '20px', minWidth: '30%' }}>
                      <Input placeholder="可输入多个商品ID，以逗号分隔开" value={skuSearch} onChange={(value) => setSkuSearch(value)} name="skuId" style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item style={{ width: '100%', flex: 0.8, textAlign: 'right', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                      <Form.Submit
                        type="primary"
                        className={`${styles.w88} ${styles.mr10}`}
                        onClick={() => getSkuList({ pageNo: 1 })}
                      >
                        查询
                      </Form.Submit>
                      <Form.Reset
                        type='normal'
                        className={styles.w88}
                        onClick={() => {
                          getSkuList({ pageSize: pageInfo.pageSize, pageNo: 1, skuIds: '' });
                          setSkuSearch('');
                        }}
                      >重置
                      </Form.Reset>
                    </Form.Item>
                  </Form>
                  <Table
                    dataSource={goodsList}
                    rowSelection={{ selectedRowKeys: skuCheckedIdCopy, onChange: changeSkusHandle }}
                    primaryKey="productId"
                    loading={goodsLoading}
                    fixedHeader
                    maxBodyHeight={(window.screen.height) * 0.6 - 200}
                  >
                    <Table.Column
                      title="商品信息"
                      dataIndex="name"
                      cell={(value, index, record) => {
                        return (<div style={{ display: 'flex' }}>
                          <img style={{ width: 60, height: 60, marginRight: 15 }} src={record.imagePath} alt="" />
                          <div style={{ paddingTop: 10 }}>{record.name}</div>
                        </div>);
                      }}
                      align="left"
                    />
                    <Table.Column title="商品ID" dataIndex="productId" width="150px" />
                    <Table.Column
                      title="价格（元）"
                      dataIndex="price"
                      width="100px"
                      cell={(value, index, record) => (
                        <div>{(+record.price).toFixed(2)}</div>
                      )}
                    />
                  </Table>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }} className="footer">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ paddingTop: 20 }}>已选择 <span style={{ color: 'red' }}>{skuCheckedCopy.length}</span> 个商品</span>
                    </div>
                    <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                    <Button
                      type="primary"
                      className={`${styles.w88} ${styles.mr10}`}
                      onClick={handleConfirm}
                    >
                      确认
                    </Button>
                    <Button
                      type="normal"
                      className={styles.w88}
                      onClick={handleCancel}
                      >
                        取消
                      </Button>
                  </div>
                </div>
              </Tab.Item>
              {/* tab2-导入商品 */}
              <Tab.Item title="导入商品" key="2" style={{ width: '120px', textAlign: 'center' }}>
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ paddingTop: '10px', paddingBottom: '15px' }}><span className={'iconfont icon-icon4-37'} style={{ paddingRight: '8px', color: '#3399FF' }} />使用导入商品功能，快速导入多个商品</div>
                  <Input.TextArea
                    placeholder="多个商品ID可以一行一个或逗号分隔"
                    aria-label="TextArea"
                    value={handleInput}
                    name="handleImport"
                    onChange={(v) => setHandleInput(v)}
                    style={{ width: '100%', marginTop: 10 }}
                    rows={20}
                  />
                  <p>成功导入 {importResult.successNum} 个，失败{importResult.failedNum}个</p>
                  <Button
                    type="primary"
                    style={{ width: '90px', marginRight: '10px' }}
                    onClick={() => {
                      handleInputConfirm();
                    }}
                  >确认导入
                  </Button>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                    <Button
                      type="primary"
                      className={`${styles.w88} ${styles.mr10}`}
                      onClick={handleConfirm}
                    >
                      确认
                    </Button>
                    <Button
                      type="normal"
                      className={styles.w88}
                      onClick={handleCancel}
                      >
                        取消
                      </Button>
                  </div>
                </div>
              </Tab.Item>
              {/* tab4-已选择商品 */}
              <Tab.Item title={`已选择商品(${skuCheckedCopy.length})个`} key="4">
                <Table dataSource={skuCheckedCopy} style={{ marginTop: '30px' }} fixedHeader maxBodyHeight={(window.screen.height) * 0.6 - 170}>
                  <Table.Column
                    title="商品信息"
                    dataIndex="commoditySelectInfo"
                    cell={(value, index, record) => {
                      return (<div style={{ display: 'flex' }}>
                        <img src={record.imagePath} style={{ width: 60, height: 60, marginRight: 15 }} alt="" />
                        <div style={{ paddingTop: 10 }}>{record.name}</div>
                      </div>);
                    }}
                    align="left"
                  />
                  <Table.Column title="商品ID" dataIndex="productId" width="150px" />
                  <Table.Column
                    title="价格（元）"
                    dataIndex="price"
                    cell={(value, index, record) => {
                      return <div>{record.price ? (+record.price).toFixed(2) : '--'}</div>;
                    }}
                    width="100px"
                  />
                  <Table.Column
                    title="操作"
                    width="80px"
                    cell={(value, index, record) => {
                      return (<div className={styles.operating} style={{ color: '#3399FF' }}>
                        <Button
                          type="primary"
                          text
                          onClick={() => {
                            // 删除商品
                            const tempDeletArr = skuCheckedCopy.filter((item) => item.productId !== record.productId);
                            setSkuCheckedCopy(tempDeletArr);
                            // 删除tab1中选中的商品
                            const skuidArr = skuCheckedIdCopy.filter((item) => item !== record.productId);
                            setSkuCheckedIdCopy(skuidArr);
                          }}
                        >删除
                        </Button>
                      </div>);
                    }}
                    align="left"
                  />
                </Table>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ paddingTop: 20 }}>已选择 <span className={styles.mustFill}>{skuCheckedCopy.length}</span> 个商品</span>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <Button
                      type="primary"
                      className={`${styles.w88} ${styles.mr10}`}
                      onClick={handleConfirm}>
                        确认
                      </Button>
                    <Button
                      type="normal"
                      className={styles.w88}
                      onClick={handleCancel}
                    >
                      取消
                    </Button>
                  </div>
                </div>
              </Tab.Item>
            </Tab>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CrowdTagSelectGoodProductId;
